import React from "react";

const WorekrFooter = () => {
   return (
      <>
         <footer className="pt-4 pt-lg-5 pb-3 font-size-16">
            <div className="container">
               <div className="row mb-lg-4 py-4 align-items-center">

                  {/* Text */}
                  <div className="col-md-7 col-lg-8 col-xl-8 mb-4 line-hight-4">
                     <p
                        className="mb-0 font-size-16 font-weight-normal line-hight-3 footer-text"

                     >

                        National Childcare Alliance Foundation
                     </p>
                     <p
                        className="mb-0 font-size-16 font-weight-normal line-hight-3 footer-text"

                     >

                        Supporting childcare providers and strengthening the early childhood workforce nationwide.
                     </p>
                  </div>

                  {/* Newsletter */}
                  <div className="col-md-5 col-lg-4 col-xl-4 mb-md-4">
                     {/* <h6 className="font-weight-semibold font-size-24 montserrat">
                        Our Newsletter
                     </h6>

                     <form className="d-flex mb-3 position-relative newsletter-box">
                        <input
                           type="email"
                           className="form-control newsletter-input rounded-pill"
                           placeholder="Your email address"
                        />
                        <button
                           className="btn newsletter-btn position-absolute rounded-pill"
                           type="submit"
                        >
                           Subscribe
                        </button>
                     </form> */}
                  </div>

               </div>

               {/* Bottom Section */}
               <div className="row py-4 align-items-start">

                  {/* LEFT SIDE – 3 Sections */}
                  <div className="col-lg-8 mb-4">

                     <div className="row gx-4">

                        <div className="col-auto">
                           <h3 className="font-weight-semibold">Let's Connect:</h3>
                           <a href={`${process.env.REACT_APP_CONTACT_US}`} className="footer-text text-decoration-underline">Contact Us</a>
                        </div>

                        <div className="col-auto">
                           <h3 className="font-weight-semibold">Email:</h3>
                           <p className="footer-text">info@ncafoundation.org</p>
                        </div>

                        {/* <div className="col">
                           <h3 className="font-weight-semibold">Address:</h3>
                           <p className="footer-text">
                              1485 Johnstons Rd. Norfolk, Virginia 23513
                           </p>
                        </div> */}

                     </div>

                  </div>

                  {/* RIGHT SIDE */}
                  <div className="col-lg-4 mb-4">
                     <h3 className="font-weight-semibold mb-3">Social media:</h3>

                     <div className="footer-social d-flex align-items-center gap-3">
                        <a href="#" className="footer-icon" aria-label="Facebook">
                           <i className="fa fa-facebook"></i>
                        </a>

                        <a href="#" className="footer-icon" aria-label="Twitter">
                           <i className="fa fa-twitter"></i>
                        </a>

                        <a href="https://www.instagram.com/nationalchildcarealliance" className="footer-icon" aria-label="Instagram">
                           <i className="fa fa-instagram"></i>
                        </a>

                        <a href="#" className="footer-icon" aria-label="Instagram">
                           <i className="fa fa-linkedin"></i>
                        </a>

                        <a href="https://www.youtube.com/@NationalChildcare" className="footer-icon" aria-label="LinkedIn">
                           <i className="fa fa-youtube"></i>
                        </a>
                     </div>
                  </div>

               </div>

               <div className="row align-items-center py-4 footer-top">

                  {/* LEFT SIDE – Logo + Copyright */}
                  <div className="col-lg-4 col-md-12 mb-3 mb-lg-0 text-center text-lg-start">
                     <img
                        src="/assets/images/NCAF_Logo.png"
                        alt="4NCAF Logo"
                        className="footer-logo mb-2"
                        style={{ width: "200px !important", height: "100px" }}
                     />

                     <p className="mb-0 footer-copy">
                        Copyright © 2026 4ncaf, All Rights Reserved
                     </p>
                  </div>

                  {/* RIGHT SIDE – Footer Links */}
                  <div className="col-lg-8 col-md-12">
                     <nav className="footer-nav">
                        <ul className="d-flex flex-wrap justify-content-center justify-content-lg-end gap-3 mb-0">
                           <li><a href={`${process.env.REACT_APP_ABOUT_US}`}>About</a></li>
                           <li><a href={`${process.env.REACT_APP_HOME_URL}`}>Support</a></li>
                           <li><a href={`${process.env.REACT_APP_PRIVACY_POLICY}`}>Privacy</a></li>
                           <li><a href={`${process.env.REACT_APP_TERMS_CONDITION}`}>Terms</a></li>
                        </ul>
                     </nav>
                  </div>

               </div>

            </div>
         </footer>
      </>
   );
};

export default WorekrFooter;
